import React from 'react';
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux'
import configureStore from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <Provider store={configureStore()}>
        <App />
    </Provider>,
   
);


